const topMain = (which) => {


  let sW = window.innerWidth;
  let sH = window.innerHeight;

  let jsSecMain = document.getElementById('jsSecMain');
  let mlBox = jsSecMain.querySelector('.js-ml-box');
  let mrBox = jsSecMain.querySelector('.js-mr-box');
  let llBox = jsSecMain.querySelector('.js-ll-box');
  let rrBox = jsSecMain.querySelector('.js-rr-box');

  let bgBox = jsSecMain.querySelector('.js-bg-box');

  let decoBox1lAll = jsSecMain.querySelectorAll('.deco-box-1-l');
  let decoBox1l1 = jsSecMain.querySelector('.js-deco-box-1-l-1');
  let decoBox1l2 = jsSecMain.querySelector('.js-deco-box-1-l-2');
  let decoBox1l3 = jsSecMain.querySelector('.js-deco-box-1-l-3');
  let decoBox1l4 = jsSecMain.querySelector('.js-deco-box-1-l-4');

  let decoBox1rAll = jsSecMain.querySelectorAll('.js-deco-box-1-r');
  let decoBox1r1 = jsSecMain.querySelector('.js-deco-box-1-r-1');
  let decoBox1r2 = jsSecMain.querySelector('.js-deco-box-1-r-2');
  let decoBox1r3 = jsSecMain.querySelector('.js-deco-box-1-r-3');
  let decoBox1r4 = jsSecMain.querySelector('.js-deco-box-1-r-4');

  let decoBox2lAll = jsSecMain.querySelectorAll('.js-deco-box-2-l');
  let decoBox2l1 = jsSecMain.querySelector('.js-deco-box-2-l-1');
  let decoBox2l2 = jsSecMain.querySelector('.js-deco-box-2-l-2');
  let decoBox2l3 = jsSecMain.querySelector('.js-deco-box-2-l-3');
  let decoBox2l4 = jsSecMain.querySelector('.js-deco-box-2-l-4');

  let decoBox2rAll = jsSecMain.querySelectorAll('.js-deco-box-2-r');
  let decoBox2r1 = jsSecMain.querySelector('.js-deco-box-2-r-1');
  let decoBox2r2 = jsSecMain.querySelector('.js-deco-box-2-r-2');
  let decoBox2r3 = jsSecMain.querySelector('.js-deco-box-2-r-3');
  let decoBox2r4 = jsSecMain.querySelector('.js-deco-box-2-r-4');

  let hodoraBox1 = jsSecMain.querySelector('.js-hodora-box-1');
  let hodoraBox2 = jsSecMain.querySelector('.js-hodora-box-2');
  let ramamaBox1 = jsSecMain.querySelector('.js-ramama-box-1');

  let logoBox = jsSecMain.querySelector('.js-logo-box');

  let moveSpeed
  let moveSpeedGap

  if (sW > 750) {
    moveSpeed = 5
    moveSpeedGap = '-=3.0'
  } else {
    moveSpeed = 3
    moveSpeedGap = '-=1.0'
    jsSecMain.style.height = `${sH - 44}px`
  }


  if (which == 'set') {

    decoBox1lAll.forEach(element => {
      gsap.set(element, {
        opacity: 0,
        x: -10,
        y: 10,
      }, 1)
    });

    decoBox1rAll.forEach(element => {
      gsap.set(element, {
        opacity: 0,
        x: 10,
        y: 10,
      }, 1)
    });

    decoBox2lAll.forEach(element => {
      gsap.set(element, {
        opacity: 0,
        x: 10,
        y: 10,
      }, 1)
    });

    decoBox2rAll.forEach(element => {
      gsap.set(element, {
        opacity: 0,
        x: -10,
        y: 10,
      }, 1)
    });

    gsap.set(logoBox, {
      opacity: 0,
    }, 1)

    gsap.set(hodoraBox1, {
      opacity: 0,
    }, 1)
    gsap.set(hodoraBox2, {
      opacity: 0,
    }, 1)

    gsap.set(ramamaBox1, {
      opacity: 0,
    }, 1)

  }

  if (which == 'start') {

    const tl = gsap.timeline();

    tl.to(mlBox, {
      xPercent: -100,
      duration: moveSpeed,
      ease: Power3.easeOut,
    }, 1)
      .to(mrBox, {
        xPercent: 100,
        duration: moveSpeed,
        ease: Power3.easeOut,
      }, '<')

      .to(decoBox1l1, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1,
      }, moveSpeedGap)
      .to(decoBox1r1, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1,
      }, '<')
      .to(decoBox1l2, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1,
      }, '>-0.5')
      .to(decoBox1r2, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1,
      }, '<')
      .to(decoBox1l3, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1,
      }, '>-0.5')
      .to(decoBox1r3, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1,
      }, '<')
      .to(decoBox1l4, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1,
      }, '>-0.5')
      .to(decoBox1r4, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1,
      }, '<')
      .to(hodoraBox1, {
        opacity: 1,
        duration: 1,
      }, '>')
      .to(ramamaBox1, {
        opacity: 1,
        duration: 1,
      }, '>-0.5')
      .to(logoBox, {
        opacity: 1,
        duration: 1,
      }, '>')
      .to(decoBox2l1, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1,
      }, '>')
      .to(decoBox2r1, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1,
      }, '<')
      .to(decoBox2l2, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1,
      }, '>-0.5')
      .to(decoBox2r2, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1,
      }, '<')
      .to(decoBox2l3, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1,
      }, '>-0.5')
      .to(decoBox2r3, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1,
      }, '<')
      .to(decoBox2l4, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1,
      }, '>-0.5')
      .to(decoBox2r4, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 1,
      }, '<')
      .to(hodoraBox1, {
        opacity: 0,
        duration: 1,
      }, '>')
      .to(hodoraBox2, {
        opacity: 1,
        duration: 1,
      }, '<')

    // .to(logoBox, {
    //   opacity: 1,
    //   duration: 1,
    // }, moveSpeedGap)
    // .to(hodoraBox, {
    //   opacity: 1,
    //   duration: 1,
    // }, '>')
    // .to(decoBox1l, {
    //   opacity: 1,
    //   x: 0,
    //   y: 0,
    //   duration: 1,
    // }, '>')
    // .to(decoBox1r, {
    //   opacity: 1,
    //   x: 0,
    //   y: 0,
    //   duration: 1,
    // }, '<')
    // .to(decoBox2l, {
    //   opacity: 1,
    //   x: 0,
    //   y: 0,
    //   duration: 1,
    // }, '>')
    // .to(decoBox2r, {
    //   opacity: 1,
    //   x: 0,
    //   y: 0,
    //   duration: 1,
    // }, '<')
  }



};
export default topMain;